import { InputHTMLAttributes, ReactNode, useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

type Props = InputHTMLAttributes<HTMLInputElement> & {
    label: string;
    leftIcon?: ReactNode;
    isPassword?: boolean;
};

export default function AuthInput({
    label,
    leftIcon,
    isPassword,
    type,
    className = '',
    ...rest
}: Props) {
    const [show, setShow] = useState(false);
    const inputType = isPassword ? (show ? 'text' : 'password') : type || 'text';

    return (
        <div className="w-full">
            <label className="mb-1.5 block text-[13px] font-semibold text-ryd-headerTextPrimary">
                {label}
            </label>
            <div className="relative">
                {leftIcon ? (
                    <span className="pointer-events-none absolute left-3.5 top-1/2 -translate-y-1/2 text-ryd-primary">
                        {leftIcon}
                    </span>
                ) : null}
                <input
                    {...rest}
                    type={inputType}
                    className={`w-full rounded-[12px] border border-[#E8E0EC] bg-white py-3 text-[14px] text-[#334155] outline-none transition placeholder:text-[#94a3b8] focus:border-ryd-primary focus:ring-2 focus:ring-ryd-primary/15 ${
                        leftIcon ? 'pl-11' : 'pl-4'
                    } ${isPassword ? 'pr-11' : 'pr-4'} ${className}`}
                />
                {isPassword ? (
                    <button
                        type="button"
                        tabIndex={-1}
                        onClick={() => setShow((v) => !v)}
                        className="absolute right-3.5 top-1/2 -translate-y-1/2 text-[#94a3b8] hover:text-ryd-primary"
                        aria-label={show ? 'Hide password' : 'Show password'}
                    >
                        {show ? <EyeOff size={18} /> : <Eye size={18} />}
                    </button>
                ) : null}
            </div>
        </div>
    );
}
